import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: "pusher",
    key: process.env.REACT_APP_WEBSOCKET_KEY,
    wsHost: process.env.REACT_APP_WEBSOCKET,
    wsPort: 443,
    wssPort: 443,
    forceTLS: true,       // must match your working setup
    encrypted: true,      // also required for wss
    cluster: "mt1",
    disableStats: true,
    enabledTransports: ["ws", "wss"],
});

